import {
  toWSDateString,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { PayableRow } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { selectorSearchRowName } from "../../../../shared/selectors/selectorSearchRowName";
import { selectorSearchRowSecondaryName } from "../../../../shared/selectors/selectorSearchRowSecondaryName";
import { getPayableStatusPill } from "./getPayableStatusPill";

type GetColumnsOptions = {
  // Which date to surface in the date column — the section already tells us
  // whether a row is unpaid (show when it's due) or paid (show when it was
  // paid).
  dateField: "due" | "paid";
};

export const getColumns = (
  options: GetColumnsOptions
): WSTableColumn<PayableRow>[] => [
  {
    config: {
      gridTemplateSizeMax: "2fr",
      header: { text: "Contractor" }
    },
    renderFunction: item => (
      <WSTableCell
        text={selectorSearchRowName(item.data) || "Contractor"}
        secondaryText={selectorSearchRowSecondaryName(item.data)}
        truncationOptions={{ text: { allowTwoLines: true } }}
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "1fr",
      header: { text: "Amount" }
    },
    renderFunction: item => (
      <WSTableCell
        text={
          item.data.amount !== undefined && item.data.currency
            ? formatMoney(item.data.amount, item.data.currency)
            : "-"
        }
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "1fr",
      hideOnScreens: ["XS", "S"],
      header: { text: options.dateField === "due" ? "Due date" : "Paid date" }
    },
    renderFunction: item => {
      const date =
        options.dateField === "due"
          ? item.data.dueDate
          : item.data.events?.paidAt;
      return (
        <WSTableCell text={date ? toWSDateString(date, "monthDayYear") : "-"} />
      );
    }
  },
  {
    config: {
      gridTemplateSizeMax: "1.5fr",
      header: { text: "Status" }
    },
    renderFunction: item => (
      <WSTableCell pill={getPayableStatusPill(item.data)} />
    )
  }
];
